"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @deprecated use SaleTag from foundation/SaleTag
 */
export const Tag = createSVGIcon(
  <>
    <path
      d="M16 9.85474L16 0.999992"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="bevel"
    />
    <path
      d="M22.1041 3.15369H9.68431C9.3723 3.15369 9.07818 3.29932 8.88903 3.54745L7.20472 5.75695C7.07192 5.93115 7 6.14414 7 6.36319V28C7 28.5523 7.44772 29 8 29H24C24.5523 29 25 28.5523 25 28V6.39209C25 6.1554 24.916 5.92638 24.7631 5.74577L22.8671 3.50737C22.6771 3.28305 22.398 3.15369 22.1041 3.15369Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M19.1071 9.85474C19.1071 11.5249 17.7276 12.8996 16 12.8996C14.2724 12.8996 12.8929 11.5249 12.8929 9.85474C12.8929 8.18455 14.2724 6.80985 16 6.80985C17.7276 6.80985 19.1071 8.18455 19.1071 9.85474Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </>,
  "TagIcon",
  { viewBox: "0 0 30 30", fill: "none" }
);
